<template>
  <div>
    <GeneralTheme :theme="configuration">
      <div
        :class="{
          'container mx-auto max-w-[665px] p-0': !fullWidthContent,
        }"
      >
        <Form
          v-if="form"
          v-bind="form"
        />
      </div>
    </GeneralTheme>
  </div>
</template>
<script setup lang="ts">
import Form from './Form.vue';
import GeneralTheme from '~/components/Molecules/Themes/GeneralTheme.vue';
import type { SectionBuilderForm } from '~/sanity/types';

defineProps<SectionBuilderForm>();
</script>

<style lang="scss" scoped></style>
